import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/AuthStore';
import '../styles/LoginPage.css';

export const LoginPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await authStore.login(email, password);

    if (authStore.isAuthenticated) {
      navigate('/calendar');
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-section mobile-hide">
      </div>

      <div className="login-form-section">
        <div className="login-card">
          <div className='pb-5'><img src="logo.png" className='w-100' /></div>

          {/* <h1>Admin</h1> */}

          {authStore.error ? <div className="error-message">{authStore.error}</div> :
            <></>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="admin@tentpen.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>



            <button type="submit" disabled={authStore.isLoading} className="login-button">
              {authStore.isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <p className="login-hint">
            <i className="fa-regular fa-envelope"></i> info@tentpen.co.za
          </p>
        </div>
      </div>
    </div>
  );
});
